import { DataField } from '../DataField';
import { DataType } from '../DataType';
import { Engine } from '../Engine';
import { RoleType, VariableType } from '../Field';
import { Model } from '../Model';
import { ColumnType } from '../Store/Column';
export class ModelBuilder {
    build(dataset) {
        const adapter = this.buildAdapter(dataset);
        const fields = this.buildFields(dataset);
        return new Model(adapter, fields);
    }
    buildAdapter(dataset) {
        return new Engine(dataset);
    }
    buildFields(dataset) {
        const result = new Array();
        for (const column of dataset.schema.columns) {
            switch (column.type) {
                case ColumnType.FLOAT:
                    result.push(new DataField(column, DataType.FLOAT, RoleType.MEASURE, VariableType.CONTINUOUS, column.name));
                    break;
                case ColumnType.INTEGER:
                    result.push(new DataField(column, DataType.INTEGER, RoleType.MEASURE, VariableType.CONTINUOUS, column.name));
                    break;
                case ColumnType.BOOLEAN:
                    result.push(new DataField(column, DataType.BOOLEAN, RoleType.MEASURE, VariableType.DISCRETE, column.name));
                    break;
                case ColumnType.STRING:
                    result.push(new DataField(column, DataType.STRING, RoleType.DIMENSION, VariableType.DISCRETE, column.name));
                    break;
                case ColumnType.DATE:
                    result.push(new DataField(column, DataType.DATE, RoleType.DIMENSION, VariableType.DISCRETE, column.name));
                    break;
                case ColumnType.DATETIME:
                    result.push(new DataField(column, DataType.DATETIME, RoleType.DIMENSION, VariableType.DISCRETE, column.name));
                    break;
            }
        }
        return result;
    }
}
